import { css } from 'styled-components';
import { Breakpoints } from '@01_people/ui-library';

export default () => css`
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: 'Roboto Condensed', sans-serif;
  }

  div.txt-inp.is-errors {
    margin-bottom: 8px !important;
  }

  div.errors {
    margin-bottom: 8px;
  }

  .react-select__control--is-disabled {
    background: ${({ theme }) => theme.colors.gray.shades['95']}!important;
  }

  .vertical-center {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .camera-modal__close-btn {  
    z-index: 1;
    fill: white;
  }

  .loading-overlay {
    background-color: rgba(0, 0, 0, 0.5);
    .loading-modal {
      width: 80px;
      height: 80px;
      border-radius: 8px;
      background: white;
      box-shadow: 0 12px 30px 0 rgba(0, 0, 0, 0.09);
    }
  }

  /* Info modal */
  .info-overlay {
    background-color: rgba(0, 0, 0, 0.5);
    .info-modal {
      max-width: 394px;
      width: 100%;
      text-align: center;
      border-radius: 5px;
      padding: 22px;

      .totp-modal {
        overflow-x: scroll;
        max-height: 80vh;
      }

      .blur-svg {
        display: none;
      }

      transition: 0.2s filter linear;

      .info-modal--blurred {
        filter: url(#blur-filter);
        filter: blur(17.5px);
      }

      &__close-btn {
        cursor: pointer;
        top: 17px;
        right: 17px;
        svg {
          width: 21px;
          height: 21px;
          fill: ${({ theme }) => theme.colors.gray.color};
        }

        &--hidden {
          display: none;
        }
      }

      &.change-process {
        max-width: 600px;
        padding: 50px;

        span.sms-icon-change {
          width: 1px;
          height: 1px;

          /* svg {
            & > g > rect {
              fill: #346ffe;
            }

            g.icon-path {
              fill: #346ffe;
            }
          } */
        }

        p.ga-recovery-code {
          color: ${({ theme }) => theme.colors.gray.color};
          word-wrap: break-word;
        }

        span.sms-verification-svg {
          svg {
            rect {
              fill: ${({ theme }) => theme.colors.primary.color};
            }
            g > g > g {
              fill: ${({ theme }) => theme.colors.primary.color};
            }
          }
        }

        .change-process-modal {
          div.errors {
            text-align: left;
          }

          img.totp-qr-code {
            margin-bottom: 24px;
          }

          .text-error {
            margin-top: 8px;
            margin-bottom: 8px;
            text-align: left;
            font-size: 12px;
            line-height: 1.33;
            letter-spacing: 0.5px;
            color: ${({ theme }) => theme.colors.error.color};
          }

          &__heading {
            margin-top: 25px;
          }

          &__description {
            margin-bottom: 24px;
          }

          &__input {
            &.is-errors {
              margin-bottom: 4px !important;
            }
            margin-bottom: 16px;
          }

          div.phone {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            width: 100%;

            &__right {
              flex: 1;
            }

            .phone-prefix {
              min-width: 180px;
              height: 56px;
              margin-right: 15px;
              .react-select__control {
                height: 56px;
              }
            }
            .phone-number {
              min-width: 209px;
              width: 100%;
            }
          }

          .mt-16 {
            margin-top: 16px;
          }
        }
      }
    }

    .camera-overlay {
      background-color: rgba(0, 0, 0, 0.7);

      .styles_modal__gNwvD {
        padding: 0 !important;
      }

      .camera-modal {
        width: 100%;
        text-align: center;
        border-radius: 5px;
        padding: 0 !important;

        &__close-btn {
          cursor: pointer;
          top: 17px;
          right: 17px;
          z-index: 1;
          fill: #fff;

          /* svg {
            width: 21px;
            height: 21px;
            display: relative;
            z-index: 10;
            fill: #fff;
            color: white;
            path {
              fill: white;
            }
          } */

          &--hidden {
            display: none;
          }
        }
      }
    }
  }

  @media (max-width: ${Breakpoints.maxSmall}) {
    .ceqMqW {
      min-height: 0px;
      padding-top: 0px;
      border-top: solid 1px #f2f4f7;
    }

    .gGdEto {
      margin-bottom: 0;
    }

    .sc-kpOJdX {
      height: 100%;
    }

    .info-overlay {
      background-color: rgba(0, 0, 0, 0.7);
      padding: 0;
      max-width: none;
      max-height: none;

      .info-modal {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        height: 100vh;
        width: 100vw;
        max-width: none;
        max-height: none;
        border-radius: 0;

        &.change-process {
          max-width: none;
          max-height: none;
          padding: 0 30px;
          padding-top: 50px;
          padding-bottom: 10px;
        }

        .totp-modal {
          max-height: none;
          max-width: 100%;
          padding: 0;
        }
      }
    }

    /* .container {
      padding-bottom: 0px !important;
    } */

    .camera-overlay {
      background-color: rgba(0, 0, 0, 0.7);
      padding: 0;
      overflow: hidden;

      .camera-modal {
        width: 100vw;
        height: 100vh;
        text-align: center;
        border-radius: 5px;
        padding: 0 !important;

        &__close-btn {
          svg {
            fill: white;
          }
        }

        &__close-btn {
          cursor: pointer;
          top: 17px;
          right: 17px;

          svg {
            width: 21px;
            height: 21px;
            display: relative;
            z-index: 10;
            fill: #fff;
          }

          &--hidden {
            display: none;
          }
        }
      }
    }

    button {
      font-size: 14px;
      font-weight: bold;
      line-height: 1.43;
      letter-spacing: 0.5px;
      height: 40px;
      padding: 10px 15px;

      &.btn {
        font-size: 14px;
        font-weight: bold;
        line-height: 1.43;
        letter-spacing: 0.5px;
        height: 40px;
        padding: 10px 15px;
      }
    }
  }

  /* Loader spinning */
  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  .btn-link {
    color: ${({ theme }) => theme.colors.primary.color};
    background: none;
    border: none;

    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.5;
    letter-spacing: normal;

    &:hover,
    &:active {
      text-decoration: underline;
    }

    &:disabled {
      color: ${({ theme }) => theme.colors.primary.shades['79']};
      text-decoration: none;
    }
  }

  .check-icon-wrapper > svg > g > g {
    fill: ${({ theme }) => theme.colors.primary.color};
  }
`;
